/* ==========================================================================
form.js
========================================================================== */

(function($) {
  /**
   * Collapse/open form sections
   */

  // First check if there is a form field with an error class, and if so, open that section
  $(document).bind('gform_post_render', function(){
    var button = $( ".gfield_error" ).parent().prev();
    button.next().slideDown('medium');
    button.children().addClass( "minus");

    $('.gform_save_link').removeAttr( "onclick onkeypress" ); // remove save button javascript

    // add description
    $('<p class="save-form-description">Voit halutessasi tallentaa lomakkeen ja jatkaa sen täyttämistä myöhemmin. Liitetiedosto eivät tallennu.</p>').insertAfter( ".gform_save_link" );

    // open all sections if there is an error
    var $error = $('.validation_error');
    if ($error.length > 0) {
      $('#open-all').trigger('click');
    }


  });

  // Clicking on a section
  $('.gform_wrapper').on('click', '.collapse-button', function() {
    $(this).next().slideToggle('medium');
    $(this).children().toggleClass( "minus" );
  } );


  // Open/close all sections
  i = 0;
  $('.gform_wrapper').on('click', '#open-all', function () {
    if(i % 2 == 0) {
      $('.collapsible').slideDown('medium');
      $('.collapse-button').children().addClass( "minus" );
      $(this).text('Sulje kaikki');
      i++;
    } else  {
      $('.collapsible').slideUp('medium');
      $('.collapse-button').children().removeClass( "minus" );
      $(this).text('Avaa kaikki');
      i++;
    }
  });

  /**
   * Add confirmation box before proceeding to save form progress
   */
  $('.gform_wrapper').on('click', '.gform_save_link', function (event) {
      var consent = confirm('Painamalla OK hyväksyt että tietojasi säilytetään palvelimella 30 päivää, tai niin kauan kunnes lähetät lomakkeen.');
      if (consent == true) {
        // Execute gravity form code if user clicks OK to consent dialog
        if (window["gf_submitting_3"] || event.keyCode == 13) {
          return false;
        }
        window["gf_submitting_3"]=true;
        jQuery("#gform_save_3").val(1);
        jQuery("#gform_3").trigger("submit",[true]);
      }
  } );

})( jQuery );
